import { createActionsHook } from "react-redux-actions-hook";
import { AppActionType } from "components/app/constants";

export const removeToastMessage = () => (dispatch) => {
  dispatch({
    type: AppActionType.REMOVE_TOAST_MESSAGE,
    payload: { message: "", type: "" },
  });
};

export const setToastMessage =
  ({ message, type }) =>
  (dispatch) => {
    dispatch({
      type: AppActionType.SET_TOAST_MESSAGE,
      payload: { message, type },
    });
  };

export const setBusy =
  ({ busy }) =>
  (dispatch) => {
    dispatch({
      type: AppActionType.APP_BUSY,
      payload: { busy },
    });
  };

export const setDrawerState = () => (dispatch) => {
  dispatch({
    type: AppActionType.SET_DRAWER_STATE,
  });
};

export const setChartDrawerState = () => (dispatch) => {
  dispatch({
    type: AppActionType.SET_CHART_DRAWER_STATE,
  });
};

export const setChartDrawerStateToClose = () => (dispatch) => {
  dispatch({
    type: AppActionType.SET_CHART_DRAWER_STATE_TO_CLOSE,
  });
};

export const disableChartDrawer = () => (dispatch) => {
  dispatch({
    type: AppActionType.DISABLE_CHART_DRAWER,
  });
};

export const enableChartDrawer = () => (dispatch) => {
  dispatch({
    type: AppActionType.ENABLE_CHART_DRAWER,
  });
};

export const changePage = (page) => (dispatch) => {
  dispatch({
    type: AppActionType.CHANGE_PAGE,
    payload: { page }
  });
};

export const setWaterUserType = (type) => (dispatch) => {
  dispatch({
    type: AppActionType.SET_WATER_USER_TYPE,
    payload: { type }
  });
}

export default createActionsHook({
  removeToastMessage,
  setToastMessage,
  setDrawerState,
  setChartDrawerState,
  setChartDrawerStateToClose,
  disableChartDrawer,
  enableChartDrawer,
  changePage,
  setWaterUserType
});
